




























































import RequestPromises from "@/mixins/requestPromises";
import _ from "@/boot/lodash";
import { Component, Mixins } from "vue-property-decorator";
import { ClientRoutes } from "@/data/enums/router";
import { QUERY_PARAMS } from "@/data/constants";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters({
      currentOauthClient: "auth/client/currentOauthClient",
      defaultOauthClient: "auth/client/defaultOauthClient",
      isSupportedOauthClient: "auth/client/isSupportedOauthClient",
      defaultOauthClientRedirect: "auth/client/defaultOauthClientRedirect"
    })
  }
})
export default class VerifyClientEmail extends Mixins(RequestPromises) {
  // Vuex Bindings

  public readonly currentOauthClient!: string;
  public readonly defaultOauthClient!: string;
  public readonly isSupportedOauthClient!: boolean;
  public readonly defaultOauthClientRedirect!: string;

  // Data

  public hasError = false;
  public reg_hash = _.get(this.$route.query, QUERY_PARAMS.HASH);
  public email_id = _.get(this.$route.query, QUERY_PARAMS.EMAIL_ID);
  public client_id = _.get(this.$route.query, QUERY_PARAMS.CLIENT_ID);
  public readonly clientDashboardRoute = { name: ClientRoutes.DASHBOARD };

  // Life-cycle methods
  public async created() {
    if (!this.isSupportedOauthClient) return;
    await this.verifyEmailAddress();
  }

  // Methods
  private async verifyEmailAddress() {
    try {
      // Verify email
      await Promise.all([
        this.$store.dispatch(
          "auth/client/verifyEmailAddress",
          _.pick(this, ["reg_hash", "client_id", "email_id"])
        ),
        // Add a small delay for improved UX
        new Promise(resolve => setTimeout(resolve, 1500))
      ]);
      // Open toast
      this.$buefy.snackbar.open({
        message: this.$t("_sentence.email_verification_successful") as string
      });
      // Redirect to dashboard (assuming logged in)
      this.$router.replace(this.clientDashboardRoute).catch(err => err);
    } catch (error) {
      this.hasError = true;
      this.$store.dispatch("api/handleError", error);
    }
  }
}
